import React, { useEffect, useState } from "react";
import "./VistaProcedimientosMensuales.css";
import AADService from "../funcionesAuth.js";

const BANCOS = ["Bancolombia", "Nequi", "Bam", "Baes"];

const VistaProcedimientosMensuales = () => {
  const API_URL = process.env.REACT_APP_API_URL;

  const [procedimientos, setProcedimientos] = useState([]);
  const [editingCell, setEditingCell] = useState(null);
  const [loading, setLoading] = useState(false);
  const AzureADService = new AADService();
  const token = AzureADService.getToken();

  useEffect(() => {
    fetchProcedimientos();
  }, []);

  const fetchProcedimientos = async () => {
    try {
      const resp = await fetch(
        `${API_URL}administrador/procedimientos/0/`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );

      if (!resp.ok) throw new Error("Error obteniendo datos");

      const data = await resp.json();
      setProcedimientos(data);
    } catch (err) {
      console.error("fetchProcedimientos:", err);
    }
  };

  const onFechaChange = (procId, banco, value) => {
    setProcedimientos((prev) =>
      prev.map((p) =>
        p.idprocedimientos_mensuales === procId
          ? { ...p, [banco]: value }
          : p
      )
    );
  };

  const guardarCambios = async () => {
    setLoading(true);
    try {
      const payload = procedimientos.map((p) => ({
        idprocedimientos_mensuales: p.idprocedimientos_mensuales,
        procedimiento: p.procedimiento,
        Bancolombia: p.Bancolombia || "",
        Nequi: p.Nequi || "",
        Bam: p.Bam || "",
        Baes: p.Baes || "",
      }));

      const resp = await fetch(
        `${API_URL}administrador/procedimientos/0/`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify(payload),
        }
      );

      if (!resp.ok) throw new Error("Error guardando");

      alert("✅ Cambios guardados correctamente");
      setEditingCell(null);
      fetchProcedimientos();
    } catch (err) {
      console.error("guardarCambios:", err);
      alert("❌ Error al guardar");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="vpm-root">
      <div className="vpm-header">
        <h2>Procedimientos Mensuales</h2>
        <button className="vpm-btn vpm-btn-light" onClick={fetchProcedimientos}>
          Actualizar
        </button>
      </div>

      <div className="vpm-table-wrap">
        <table className="vpm-table">
          <thead>
            <tr>
              <th>Proceso</th>
              {BANCOS.map((b) => (
                <th key={b}>{b}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {procedimientos.map((p) => (
              <tr key={p.idprocedimientos_mensuales}>
                <td className="vpm-proceso">{p.procedimiento}</td>

                {BANCOS.map((banco) => {
                  const cellKey = `${p.idprocedimientos_mensuales}-${banco}`;
                  const editing =
                    editingCell?.procId === p.idprocedimientos_mensuales &&
                    editingCell?.banco === banco;

                  return (
                    <td key={cellKey} className="vpm-cell">
                      {editing ? (
                        <input
                          type="date"
                          value={p[banco] || ""}
                          onChange={(e) =>
                            onFechaChange(
                              p.idprocedimientos_mensuales,
                              banco,
                              e.target.value
                            )
                          }
                          onBlur={() => setEditingCell(null)}
                        />
                      ) : (
                        <>
                          <span>{p[banco] || "—"}</span>
                          <button
                            className="vpm-edit-btn"
                            onClick={() =>
                              setEditingCell({
                                procId: p.idprocedimientos_mensuales,
                                banco,
                              })
                            }
                          >
                            ✏️
                          </button>
                        </>
                      )}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="vpm-actions">
        <button className="vpm-btn" onClick={guardarCambios} disabled={loading}>
          {loading ? "Guardando..." : "Guardar cambios"}
        </button>
      </div>
    </div>
  );
};

export default VistaProcedimientosMensuales;